import axios from "axios";

const GAME_URL = process.env.REACT_APP_GAME_API_URL
  ? process.env.REACT_APP_GAME_API_URL
  : "https://test-gameapi.runnerrunner.co.kr";

const APP_PASSWORD = "qlrnqofiwjdo1932938@#@#1";
const GAMEAPI = {
  getTournamentList() {
    const token = localStorage.getItem("token");
    return axios
      .get(GAME_URL + "/api/get_tournament_list", {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((res) => res);
  },
  getJoinSetting() {
    const token = localStorage.getItem("token");
    return axios
      .get(GAME_URL + "/api/get_join_setting", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res);
  },
  getGameDashboard() {
    return axios
      .get(GAME_URL + "/api/dashborad/gp", {
        params: {
          password: APP_PASSWORD,
          startDate: "2024-04-01",
          endDate: "2099-04-30",
        },
      })
      .then((res) => res.data.list);
  },
  getUserGamePointList(
    page: number = 0,
    searchOption: string = "",
    searchText: string = ""
  ) {
    return axios
      .get(GAME_URL + "/api/user/point/list", {
        params: {
          page,
          searchOption,
          searchText,
          password: APP_PASSWORD,
        },
      })
      .then((res) => res.data.payload);
  },
  saveGameSetting(body: any) {
    const token = localStorage.getItem("token");
    return axios
      .post(GAME_URL + "/api/set_join_setting", body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res);
  },
  addPointRebuyin(body: any) {
    const token = localStorage.getItem("token");
    return axios
      .post(GAME_URL + "/api/add_point_rebuyin", body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res);
  },
  getPointAndRebuyIn(id: number) {
    return axios
      .get(GAME_URL + `/api/get_user_ticket_info?userId=${id}`)
      .then((res) => res.data.user);
  },
  getCouponList(
    page: number = 0,
    searchOption: string = "",
    searchText: string = ""
  ) {
    return axios
      .get(GAME_URL + `/api/coupon/list`, {
        params: {
          page,
          searchOption,
          searchText,
          password: APP_PASSWORD,
        },
      })
      .then((res) => res);
  },
  getClubList(
    page: number = 1,
    limit: number = 20,
    startDate?: string,
    endDate?: string
  ) {
    const token = localStorage.getItem("token");
    return axios
      .get(GAME_URL + `/api/club`, {
        params: {
          password: APP_PASSWORD,
          page,
          limit,
          token,
          startDate,
          endDate,
        },
      })
      .then((res) => res);
  },
  getMemberList(clubId: number, startDate?: string, endDate?: string) {
    return axios
      .get(GAME_URL + `/api/club/admin/detail/${clubId}/members`, {
        params: {
          page: 1,
          limit: 10000,
          startDate,
          endDate,
          password: APP_PASSWORD,
        },
      })
      .then((res) => res);
  },
  getMyClub(clubId: number, startDate?: string, endDate?: string) {
    return axios
      .get(GAME_URL + `/api/club/admin/${clubId}`, {
        params: {
          password: APP_PASSWORD,
          startDate,
          endDate,
        },
      })
      .then((res) => res);
  },
  getGameUserList(
    page: number,
    limit: number,
    nickname?: string,
    clubId?: number | null
  ) {
    return axios
      .get(GAME_URL + `/api/user/admin/list`, {
        params: {
          password: APP_PASSWORD,
          page,
          limit,
          nickname,
          clubId,
        },
      })
      .then((res) => res);
  },
  sendGameMessage(
    senderUserId: number,
    receiverUserIds: number[],
    message: string
  ) {
    const request = {
      password: APP_PASSWORD,
      senderUserId,
      receiverUserIds,
      message,
    };
    return axios
      .post(GAME_URL + `/api/user/admin/chat/send`, request)
      .then((res) => res);
  },
  generateCoupon(body: {
    code: string;
    codeCount: number;
    isCommon: boolean;
    rewardList: {
      rebuyinTicket: number;
      point: number;
    };
    tag: string;
    couponType: string;
    endedAt: string;
    couponLength: number;
  }) {
    return axios
      .post(GAME_URL + `/api/coupon/generate`, {
        ...body,
        password: APP_PASSWORD,
      })
      .then((res) => res);
  },
  createClub(
    name: string,
    description: string,
    profileType: number,
    token: string
  ): Promise<{ result: number; message: string }> {
    const request = new FormData();
    request.append("name", name);
    request.append("description", description);
    request.append("profileType", profileType.toString());
    request.append("token", token);
    return axios
      .post(GAME_URL + `/api/club`, request, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res.data);
  },

  deleteMember(userId: number, clubId: number) {
    const request = {
      password: APP_PASSWORD,
    };
    return axios
      .post(
        GAME_URL + `/api/club/admin/member/delete/${clubId}/${userId}`,
        request
      )
      .then((res) => res);
  },
};
export default GAMEAPI;
